module.exports = __webpack_public_path__ + "static/media/icon_lens_adding.a8983ee8.png";